module.exports = __webpack_public_path__ + "static/media/schnee-kugeln.7455261d.png";